import { Icon } from "@brexhq/metal-icon";
import styled from "@emotion/styled";
import { darken } from "polished";
import React from "react";

import { IBynderVideoWithCaption } from "@brexhq/shared/types/BynderAsset";

import { VideoButton } from "../../shared/Chip/VideoButton";

interface LightboxVideoLinkProps {
  label: string;
  video: IBynderVideoWithCaption;
  lightMode?: boolean;
  videoMaxWidth?: string;
}

const LightboxVideoLinkContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 28px 0;
  cursor: pointer;
  gap: 8px;

  & > span {
    color: ${({ theme }) => theme.colors.accent.primary.background.default};
  }

  & > div > svg {
    color: ${({ theme }) => theme.colors.accent.primary.background.default};
  }

  &:hover > div > svg {
    color: ${({ theme }) =>
      darken(0.2, theme.colors.accent.primary.background.default)};
  }

  &:hover span {
    color: ${({ theme }) =>
      darken(0.2, theme.colors.accent.primary.background.default)};
  }
`;

export const LightboxVideoLink: React.FC<LightboxVideoLinkProps> = ({
  label,
  video,
  lightMode,
  videoMaxWidth,
}) => {
  const button = (
    <LightboxVideoLinkContainer>
      <Icon name="playInCircle" size={16} />
      <span>{label}</span>
    </LightboxVideoLinkContainer>
  );

  return (
    <VideoButton
      section={label}
      topMargin={0}
      componentName="LightboxVideoLink"
      modifier="unstyled"
      label={button}
      video={video}
      lightMode={lightMode}
      maxWidth={videoMaxWidth}
    />
  );
};
